<template>
  <div class="schedule-modal">
    <div class="content">
      <h3 class="schedule-title">{{ $t('scheduled_delivery') }}</h3>
      <div class="ninety">
        <p class="schedule-txt">{{ $t('expected_delivery') }}:</p>
        <p class="schedule-txt">{{this.structureDate(orderDetail.DispatchDate)}}</p>
<!--        <p class="schedule-txt">{{orderDetail.DispatchDate}}</p>-->
      </div>
      <div class="ninety">
        <p class="schedule-txt">{{ $t('ship_to') }}:</p>
        <p class="schedule-txt" v-if="orderDetail.Shipping_Address">{{orderDetail.Shipping_Address.Street}}, {{orderDetail.Shipping_Address.City}} WA, {{orderDetail.Shipping_Address.Zip}}</p>
      </div>
    </div>
    <div class="tracker">
      <ul class="progress-bar">
        <li :class="orderDetail.ShippingStatus === 'Open' ? 'active-point' : 'point'"></li>
        <li :class="orderDetail.ShippingStatus === 'Scheduled' ? 'active-point' : 'point'"></li>
        <li :class="(orderDetail.ShippingStatus === 'Ready' || orderDetail.ShippingStatus === 'Shipping') ? 'active-point' : 'point'"></li>
        <li :class="orderDetail.ShippingStatus === 'Delivered' ? 'active-last-point' : 'last-point'"></li>
      </ul>
      <ul class="progress-head">
        <li :class="orderDetail.ShippingStatus === 'Open' ? 'active-delivery-txt' : 'delivery-txt'">Order Received</li>
        <li :class="orderDetail.ShippingStatus === 'Scheduled' ? 'active-delivery-txt' : 'delivery-txt'">Confirmed</li>
        <li :class="(orderDetail.ShippingStatus === 'Ready' || orderDetail.ShippingStatus === 'Shipping') ? 'active-delivery-txt' : 'delivery-txt'">In Transit</li>
        <li :class="orderDetail.ShippingStatus === 'Delivered' ? 'active-delivery-txt' : 'delivery-txt'">Delivered</li>
      </ul>
    </div>
     <div class="close-modal">
        <img
          @click="toggleOrderModal(false)"
          src="../../assets/img/closemodal.png"
          alt=""
        />
    </div>
    <div class="continue-container">
      <button class="continue-button" @click="toggleOrderModal(false)">Done</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import moment from 'moment';
export default {
  name: "register",
  data() {
    return {
      orderDetail: {}
    }
  },
  methods: {
    ...mapMutations('orders', ['toggleOrderModal']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','fetchSODetails','fetchSIDetails', 'fetchOrderDetails']),
      fetchOrderDetail(orderId) {
        this.fetchSODetails(orderId)
        .then(res => {
          console.log("res.data:", res.data)
          this.orderDetail = res.data;
        })
        .catch(err => {
          console.log('fetchOrderDetail error: ', err);
        })
      },
      structureDate(date) {
        // 星期
        const str1 = moment(date).format('dddd')
        // 日期
        const str2 = moment(date).format("MM/DD/YY")
        // 时间
        const str3 = moment(date).format("h:mm a")
        return `${str1}, ${str2}, by ${str3}`; // Thursday Feb 2015
      },
  },
  mounted() {
    this.fetchOrderDetail(this.order.SalesOrder_id);
  },
  computed: mapState({
    orderModalVisible: state => state.orders.orderModalVisible,
    loggedIn: state => state.auth.loggedIn,
    orderTimeFrame: state => state.order.orderTimeFrame,
    userDetails: state => state.auth.userDetails,
    order: state => state.orders.order
  }),
  watch: {
  },
};
</script>

<style scoped lang="less">
@import "../../assets/css/deliveryModal.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/deliveryModal.vue